import {t} from "@lingui/core/macro";

import {getPromptVariables} from "@khan/guide-core-helpers";
import {GuideStateApi} from "@khan/guide-state";

/**
 * Get classroom page metadata including title and type.
 */
export const getClassroomPageMetadata = (isClassroomPage: boolean) => {
    if (!isClassroomPage) {
        return {};
    }

    const botName = GuideStateApi.latest().selectedBotName ?? "";
    const promptVariables = getPromptVariables();

    const derivePageTypeFromBotName = (botName: string) => {
        if (botName === "classroom-learner-exercise") {
            return "exercise";
        }
        return "*";
        // TODO: TUT-2231 for assigned ai activities
    };

    const pageType = derivePageTypeFromBotName(botName);
    const pageTitle = promptVariables.contentTitle ?? t`Tutor me`;

    return {
        pageType,
        pageTitle,
    };
};
